export default {
	EMPLOYMENT_WORKPLACES: 'Employment Workplaces',
	EMPLOYMENT_WORKPLACE_REMOVED: 'Employment Workplace Removed',
	EMPLOYMENT_WORKPLACE_CREATED: 'Employment Workplace Created',
	EMPLOYMENT_WORKPLACE_UPDATED: 'Employment Workplace Updated',
};
